/**
 * CreatiCore wordmark. Source asset is hosted in /public.
 * Variants:
 *   - "dark"  (default) — original black wordmark, for light backgrounds
 *   - "light"           — white wordmark, for dark backgrounds (TV overlay, etc.)
 * Sizing: pass any tailwind height class via `className` (e.g. "h-6", "h-10").
 * The image is auto-cropped (no whitespace) so it scales cleanly.
 */
export default function Brand({ variant = "dark", className = "h-7", alt = "CreatiCore" }) {
  const src = variant === "light" ? "/creaticore-logo-white.png" : "/creaticore-logo.png";
  return <img src={src} alt={alt} className={`${className} w-auto select-none`} draggable={false} />;
}
